<template>
  <label
    class="slideshow-switch"
    :class="{ 'is-disabled': disabled, 'is-sub': sub }"
  >
    <!-- An instant setting, so a switch rather than a form checkbox; the whole row toggles it. -->
    <span>{{ label }}</span>
    <input
      class="slideshow-switch__input"
      role="switch"
      type="checkbox"
      v-model="on"
      :aria-checked="on"
      :disabled="disabled"
    >
    <span aria-hidden="true" class="slideshow-switch__track" />
  </label>
</template>

<script lang="ts" setup>
  defineProps<{
    label: string;
    disabled?: boolean;
    /** Belongs to the switch above it (indented, smaller). */
    sub?: boolean;
  }>();
  const on = defineModel<boolean>({ required: true });
</script>
